// Typelizer digest f7e83428233c31b8c7f6ce8909667785
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/documents/delivery_dates */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/documents/delivery_dates', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/documents/delivery_dates/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/documents/delivery_dates/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/documents/delivery_dates/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/delivery_dates/:id', params, options),
    method: 'patch',
  }),
}
